export default __webpack_public_path__ + "1f5f976ddb1c4ff8eb6a2bc10e5cb972.svg";